// let _history;

// function init(history) {
//   _history = history;
// }

// function navigate(url) {
//   _history.push(url);
// }

// const NavigationService = {
//   init,
//   navigate,
// }

// export default NavigationService;

class NavigationService {
  init(history) {
    this.history = history;
  }

  navigate(url) {
    this.history.push(url);
  }
}

export default new NavigationService();